export const Reply = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <g clipPath="url(#clip0_2730_14844)">
      <path
        d="M8.622 1.99982C8.48215 1.86001 8.30398 1.7648 8.11003 1.72623C7.91608 1.68767 7.71505 1.70747 7.53235 1.78314C7.34965 1.85881 7.19348 1.98695 7.0836 2.15136C6.97371 2.31577 6.91504 2.50907 6.915 2.70682V3.49982H4.5C3.30693 3.50114 2.16311 3.97567 1.31948 4.8193C0.475854 5.66293 0.00132343 6.80675 0 7.99982L0 11.4998C0 11.6324 0.0526784 11.7596 0.146447 11.8534C0.240215 11.9471 0.367392 11.9998 0.5 11.9998C0.632608 11.9998 0.759785 11.9471 0.853554 11.8534C0.947322 11.7596 1 11.6324 1 11.4998C1.00079 10.7044 1.31712 9.94181 1.87956 9.37937C2.44199 8.81694 3.20459 8.50061 4 8.49982H6.915V9.29282C6.91504 9.49057 6.97371 9.68387 7.0836 9.84828C7.19348 10.0127 7.34965 10.1408 7.53235 10.2165C7.71505 10.2922 7.91608 10.312 8.11003 10.2734C8.30398 10.2348 8.48215 10.1396 8.622 9.99982L11.5615 7.06032C11.8427 6.77903 12.0007 6.39756 12.0007 5.99982C12.0007 5.60207 11.8427 5.22061 11.5615 4.93932L8.622 1.99982Z"
        fill="#CFCDD6"
      />
    </g>
    <defs>
      <clipPath id="clip0_2730_14844">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
